// Dependencies
import React, { useEffect } from "react"
import { navigate } from "gatsby"
import fetch from "isomorphic-fetch"
import Client from "shopify-buy"

const client = Client.buildClient(
  {
    domain: process.env.GATSBY_SHOPIFY_STORE_URL,
    storefrontAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
  },
  fetch
)

const defaultValues = {
  cart: [],
  loading: false,
  addVariantToCart: () => {},
  removeLineItem: () => {},
  updateLineItem: () => {},
  getVariantForOptions: () => {},
  client,
  checkout: {
    lineItems: [],
  },
}

export const ShopContext = React.createContext(defaultValues)

export function useShopContext() {
	return React.useContext(ShopContext)
}

const isBrowser = typeof window !== `undefined`
const localStorageKey = `frbp_checkout_id`

export const ShopProvider = ({ children }) => {

  const [checkout, setCheckout] = React.useState(defaultValues.checkout)
  const [loading, setLoading] = React.useState(false)
  const [didJustAddToCart, setDidJustAddToCart] = React.useState(false)

  const setCheckoutItem = (checkout) => {
    if (isBrowser) {
      localStorage.setItem(localStorageKey, checkout.id)
    }

    setCheckout(checkout)
  }

	// INIT
  React.useEffect(() => {
    const initializeCheckout = async () => {
      const existingCheckoutID = isBrowser
        ? localStorage.getItem(localStorageKey)
        : null

      if (existingCheckoutID && existingCheckoutID !== `null`) {
        try {
          const existingCheckout = await client.checkout.fetch(
            existingCheckoutID
          )
          if (!existingCheckout.completedAt) {
            setCheckoutItem(existingCheckout)
            return
          }
        } catch (e) {
          localStorage.setItem(localStorageKey, null)
        }
      }

      const newCheckout = await client.checkout.create()
      setCheckoutItem(newCheckout)
    }

    initializeCheckout()
  }, [])

	// CREATE
  const addVariantToCart = (variantId, quantity) => {
    setLoading(true)

    const lineItemsToUpdate = [
      {
        variantId,
        quantity,
      },
    ]

    return client.checkout
      .addLineItems(checkout.id, lineItemsToUpdate)
      .then((res) => {
				// Housekeeping...
        setCheckout(res)
        setLoading(false)
				navigate('/cart/')
        // setDidJustAddToCart(true)
        // setTimeout(() => setDidJustAddToCart(false), 3000)
      })
  }

	// UPDATE
	const updateLineItem = (lineItemId, quantity) => {
    setLoading(true)

    const lineItemsToUpdate = [
      { id: lineItemId, quantity: quantity },
    ]

    return client.checkout
      .updateLineItems(checkout.id, lineItemsToUpdate)
      .then((res) => {
        setCheckout(res)
        setLoading(false)
      })
  }

	// REMOVE
  const removeLineItem = (lineItemId) => {
    setLoading(true)

		if (lineItemId) {
			return client.checkout
				.removeLineItems(checkout.id, [lineItemId])
				.then((res) => {
					setCheckout(res)
					setLoading(false)
				})
		} else {
			setLoading(false)
			return
		}
  }

  return (
    <ShopContext.Provider
      value={{
        ...defaultValues,
        addVariantToCart,
        removeLineItem,
				updateLineItem,
        checkout,
        loading,
        didJustAddToCart
      }}
    >
      {children}
    </ShopContext.Provider>
  )
}
